module.exports = __webpack_public_path__ + "media/30.7a1b9fff.mp3";